import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../../../assets/css/Ucollection.css";
import Umadras from '../../../assets/images/umadras.png';
import Unavbar from "../UnavbarComp/Unavbar";
import Footer from "../../HomeLandingComp/FooterComp/Footer";
import apiService from "../../../ApiServices/ApiServices";
import Pagination from "../../PaginationComp/Pagination";
import { FaShoppingCart } from "react-icons/fa"; // Import cart icon
import { useCart } from "../../CartContext/CartContextComp"; // Import cart context
import CartSlider from "../../CartSlider/CartSliderBar";

const UcollectionList = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [cartOpen, setCartOpen] = useState(false); // State to open/close cart
  const { cartItems } = useCart(); // Get cart items from context


  useEffect(() => {
    fetchProducts(currentPage);
    window.scrollTo(0, 0);
  }, [currentPage]);

  const fetchProducts = async (page) => {
    try {
      const response = await apiService.get(process.env.REACT_APP_API_URL, {
        params: {
          brand_id: 1,  // Brand-wise filter
          // category_id: 1,
          limit: 10, // Pagination limit
          page: page // Page number
        }
      });
      
      setProducts(response.data.data);
      setLastPage(response.data.last_page);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const handleProductClick = (product) => {
    navigate(`/umadras/collections/product/${product.id}`, { state: { product } });
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= lastPage) {
      setCurrentPage(page);
    }
  };
  const handleContactClick = (e) => {
    e.preventDefault(); // Prevent default anchor behavior

    navigate("/umadras");

    setTimeout(() => {
      const contactSection = document.getElementById("contact");
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: "smooth" });
      }
    }, 100); // Small delay to ensure navigation happens first
  };

  return (
    <>
      <nav className="navbar">
        <div className="ulogo">
          <Link to="/umadras">
            <img src={Umadras} alt="Logo" className="ulogo-image" />
          </Link>
        </div>
        <div className="nav-links">
          <Link to="/umadras">Home</Link>
          <Link to="/umadras/collections">Collection</Link>
          <Link onClick={handleContactClick}>Contact Us</Link>
           {/* Cart Icon */}
           <div className="cart-container" onClick={() => setCartOpen(true)}>
            <FaShoppingCart className="cart-icon" />
            {cartItems.length > 0 && <span className="cart-count">{cartItems.length}</span>}
          </div>
        </div>
      </nav>
      {/* Cart Slider */}
      {cartOpen && <CartSlider cartItems={cartItems} onClose={() => setCartOpen(false)} />}


      <div className="collection-container">
        <h2 className="collection-title">Collection</h2>
        <div className="collection-grid">
          {products.length > 0 ? (
            products.map((product) => (
              <div key={product.id} className="collection-item" onClick={() => handleProductClick(product)}>
                <img src={`https://admin.utharamenon.com/storage/${product.product_images[0]?.image_url}`} alt={product.name} className="ucollection-image" />
                {/* <h3 className="product-name" >{product.name}</h3>
                <p className="product-price" >Rs. {product.price}</p> */}
                <div className="product-title">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-price">Rs. {product.price}</p>
                </div>
              </div>
            ))
          ) : (
            <p className="no-products">No products available</p>
          )}
        </div>

        {/* Pagination Component */}
        <Pagination
          totalPages={lastPage}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />

      </div>

      <Footer />
    </>
  );
};

export default UcollectionList;
